<template>
    <figure
        class="a-image a-image--fadeOnLoad"
        :class="{ 'a-image--modal': modal }"
    >
        <img
            class="a-image__image"
            :class="{'a-image__image--loaded': isLoaded, 'a-image__image--modal': modal, 'a-image__image--vertical': isVertical}"
            :src="src"
            :alt="alt"
            @load="onLoad"
        />
    </figure>
</template>

<script>
export default {
    data() {
        return {
            isLoaded: false,
            isVertical: false
        }
    },
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            default: ''
        },
        modal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onLoad() {
            this.isLoaded = true
            this.checkIfVertical()
        },
        checkIfVertical() {
            const imageElem = this.$el.children[0]
            if(imageElem.naturalWidth < imageElem.naturalHeight) {
                this.isVertical = true
            }
        }
    },
    mounted() {
    }
}
</script>
